export default __webpack_public_path__ + "i18n/languages.b14b597.json";